import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: ReactNode;
}
const FeaturePoint = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-6894">
      <div className="flex-shrink-0 mt-1" data-id="element-6895">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-6896" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-6897">{children}</div>
    </div>;
};
export default FeaturePoint;